import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import cn from "classnames";
import TextControl from "@ebsco-ui/text-control";

export interface TextInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string | ReactNode;
  id: string;
  className?: string;
  error?: string;
  description?: string;
  disabled?: boolean;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      id,
      className,
      label,
      error,
      description,
      disabled = false,
      ...rest
    }: TextInputProps,
    ref,
  ) => {
    const baseClassName = "eb-text-input";
    return (
      <TextControl
        className={cn(baseClassName, className)}
        label={label}
        error={error}
        description={description}
      >
        <input
          type="text"
          id={id}
          disabled={disabled}
          className={`${baseClassName}__input`}
          aria-invalid={Boolean(error)}
          aria-describedby={cn(
            description && `${id}-description`,
            error && `${id}-error`,
          )}
          ref={ref}
          {...rest}
        />
      </TextControl>
    );
  },
);

TextInput.displayName = "TextInput";

export default TextInput;
